import axios from "utils/axios";

export const WellnessHeaders = {
  "Accept-version": "2.0",
  "Cache-Control":"no-cache, private"
};

class SurveyService {
  getActiveSurveyQuestions(teamId, userId) {
    return axios.get(
      `/wellness/survey/get-current-question/${teamId}/${userId}`,
      {
        headers: WellnessHeaders,
      }
    );
  }

  //   Manage APIs
  getSurveyList(teamId) {
    return axios.get(`/wellness/survey/get-team-survey/${teamId}`, {
      headers: WellnessHeaders,
    });
  }

  getSurveyListWithPagination(teamId, page = 1, limit = 10, status_id = null, order_by = "oldest") {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      order_by: order_by,
    });
    
    if (status_id !== null && status_id !== undefined) {
      params.append("status_id", status_id.toString());
    }
    
    return axios.get(`/wellness/survey/get-team-survey/${teamId}?${params.toString()}`, {
      headers: WellnessHeaders,
    });
  }

  createSurvey(data) {
    return axios.post(`/wellness/survey/add-survey`, data, {
      headers: WellnessHeaders,
    });
  }

  getQuestionToAdd(teamId) {
    return axios.get(`/wellness/survey/get-team-question/${teamId}`, {
      headers: WellnessHeaders,
    });
  }

  createSurveyQuestion(data) {
    return axios.post(`/wellness/survey/add-survey-question`, data, {
      headers: WellnessHeaders,
    });
  }

  getSurveyQuestions(surveyId, teamId) {
    return axios.get(
      `/wellness/survey/get-survey-question/${surveyId}/${teamId}`,
      {
        headers: WellnessHeaders,
      }
    );
  }

  endSurvey(surveyId, teamId) {
    return axios.put(
      `/wellness/survey/end-survey/${surveyId}/${teamId}`,
      {},
      {
        headers: WellnessHeaders,
      }
    );
  }

  getSurveyResponses(surveyId, teamId) {
    return axios.get(
      `/wellness/survey/get-survey-response/${surveyId}/${teamId}`,
      {
        headers: WellnessHeaders,
      }
    );
  }

  exportSurvey(surveyId, teamId) {
    return axios.get(
      `/wellness/survey/export/${surveyId}/${teamId}`,
      {
        headers: WellnessHeaders,
        responseType: "blob",
      }
    );
  }

  deleteSurvey(surveyId) {
    return axios.delete(`/wellness/survey/delete-survey/${surveyId}`, {
      headers: WellnessHeaders,
    });
  }

  getTeamforshareSurvey(teamId) {
    return axios.get(`/wellness/survey/get-teams/${teamId}`, {
      headers: WellnessHeaders,
    });
  }

  submitShareSurvey(data) {
    return axios.post(`/wellness/survey/share-survey`, data, {
      headers: WellnessHeaders,
    });
  }

  submitSurvey(data) {
    return axios.post(`/wellness/survey/survey-answer`, data, {
      headers: WellnessHeaders,
    });
  }
}

export default new SurveyService();
